<div class="table-responsive" [class.overflow-hidden]="classifiedsService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover key-log-list-table footable"
           *ngIf="classifiedsService.data.allClassifieds.data.length">
        <thead>
        <tr [ngClass]="{'noSort': classifiedsService.data.allClassifieds.data.length < 2}">
            <th (click)="orderBy('keyTag', $event)" class="footable-sorted">Title<span class="footable-sort-indicator"></span></th>
            <th *ngIf="classifiedsService.buildings.length > 1"
                (click)="orderBy('building.name', $event)">Building<span class="footable-sort-indicator"></span></th>
            <th (click)="orderBy('suite.suiteNumber', $event)">Unit/Room<span class="footable-sort-indicator"></span></th>
            <th>Content</th>
            <th>Start</th>
            <th>End</th>
            <th>Posted By</th>
            <th (click)="orderBy('status', $event)">Status<span class="footable-sort-indicator"></span></th>
            <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <ng-template ngFor let-item [ngForOf]="classifiedsService.data.allClassifieds.data" let-index="index">
            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}">
                <td>{{item.title}}</td>
                <td *ngIf="classifiedsService.buildings.length > 1">{{item.buildingName}}</td>
                <td>{{item.content}}</td>
                <td>{{item.start}}</td>
                <td>{{item.end}}</td>
                <td>{{item.createdByUser}}</td>
                <td>
                    <span *ngIf="item.status === 'approved'"  class="text-uppercase label label-picked_up" >Approved</span>
                    <span *ngIf="item.status === 'pending'"  class="text-uppercase label label-received" >Pending</span>
                    <span *ngIf="item.status === 'reject'"  class="text-uppercase label label-picked_up" >Reject</span>
                    <span *ngIf="item.status === 'expired'"  class="text-uppercase label label-received" >Expired</span>
                </td>
                <td class="td-action-btn">
                    <div class="input-group-btn btn-in-table input-group">
                        <button (click)="signOutKey(item)" *ngIf="item.status === 'available'"
                                class="btn btn-white btn-xs sign-out-return-buttons">Sign Out Key</button>
                        <button (click)="returnKey(item)" *ngIf="item.status === 'signet_out'"
                                class="btn btn-white btn-xs sign-out-return-buttons">Return Key</button>
                        <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs"
                                aria-expanded="false"><span class="caret"></span></button>
                        <ul class="dropdown-menu pull-right">
                            <li (click)="getHistory(item)" ><a>History</a></li>
                            <li (click)="deleteKeyLog(item)" ><a>Delete</a></li>
                        </ul>
                    </div>
                </td>
            </tr>
        </ng-template>
        <tr *ngFor="let item of classifiedsService.emptyRowService.emptyRow" style="cursor: default;">
            <td>&nbsp;</td><td *ngIf="classifiedsService.buildings.length > 1"></td>
            <td></td><td></td><td></td><td></td><td></td>
        </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!classifiedsService.data.allClassifieds.total"
            [isLoading]="classifiedsService.spinnerShow">
        You have no classifieds listed on the system<br>
        <a href="javascript://" (click)="classifiedsService.isClassifiedsModalShow = true" class="mtv-primary-color clickable-text">add a classified</a> now
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/classifieds/classifieds-list/classifieds-list.component.html